import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  Box,
  Paper,
  Card,
  CardContent,
  FormControl,
  FormLabel,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ControlledTextInputField from "../../component/ui/FormFields/ControlledTextInputField";
import CustomButton from "../../component/ui/FormFields/Button";
import {
  addAirportRequest,
  resetAirportState,
} from "../../redux/Airports/actions/airportActions";
import {
  selectCountryAirportRequest,
  selectStateAirportRequest,
} from "../../redux/Common/selectorAction";

import { AIRPORTS, PROMOCODE } from "../../component/common/Routes/AppRoutes";
import { useNavigate } from "react-router-dom";
import {
  LocationOn,
  FlightLand,
  FlightTakeoff,
  TransferWithinAStation,
} from "@mui/icons-material";
import { fetchAllServiceRequest } from "../../redux/Service/ServiceAction";
import { min } from "date-fns";
import {
  createPromoCodeRequest,
  resetCreatePromoCode,
} from "../../redux/PromoCode/PromoCodeAction";
import { convertDateFormat } from "../../Style";

export default function CreatePromoCode({ setTab }) {
  const dispatch = useDispatch();
  const [discountType, setDiscountType] = useState();

  const {
    control,
    handleSubmit,
    watch,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {},
    mode: "onChange",
  });
  const formValue = watch();

  const loading = useSelector((state) => state.promoCode.promoCode.loading);
  const navigate = useNavigate();
  const createPromoCodeSuccess = useSelector(
    (state) => state.promoCode.promoCode.success
  );
  const createPromoCodeError = useSelector(
    (state) => state.promoCode.promoCode.error
  );

  useEffect(() => {
    if (formValue.discount_type?.value == "1") {
      setValue("discount_value", "");
    } else {
      setValue("discount_percent", "");
    }
  }, [formValue.discount_type]);

  useEffect(() => {
    setDiscountType(formValue?.discount_type?.value);
  }, [formValue.discount_type]);

  const promoFields = [
    {
      name: "title",
      label: "Title *",

      placeholder: "Enter PromoCode Title",
      rules: { required: "Discount Title is required" },
      sm: 6,
      xs: 12,
    },
    {
      name: "discount_code",

      label: "Discount Code *",
      placeholder: "Enter Discount Code",
      rules: {
        required: "Discount Code is required",
        validate: (value) => {
          if (value.length < 4) {
            return "Discount Code must be at least 4 characters";
          }

          return true;
        },
      },
      sm: 6,
      xs: 12,
    },
    {
      name: "discount_type",
      label: "Discount Type",
      placeholder: "Select Discount Type",
      options: [
        { value: "2", label: "Price ($)" },
        { value: "1", label: "Discount(%)" },
      ],
      rules: {
        required: "Select Discount Type",
      },
      sm: 6,
      xs: 12,
    },
    ...(discountType == "2"
      ? [
          {
            name: "discount_value",
            label: "Discount Value *",
            placeholder: "Enter Discount Value",
            rules: { required: "Discount Value is required" },
            sm: 6,
            xs: 12,
          },
        ]
      : [
          {
            name: "discount_percent",
            label: "Discount Percentage *",
            placeholder: "Enter Discount Percentage 0-100%",
            rules: {
              required: "Percentage is required",
              min: { value: 0, message: "Percentage should not be negative" },
              max: {
                value: 100,
                message: "Percentage must be less than or equal to 100",
              },
            },
            sm: 6,
            xs: 12,
          },
        ]),
    {
      name: "usage_limit",
      label: "Use Limit *",

      placeholder: "Set Promo Code Use Limit",
      rules: {
        required: "Promo Code Limit is Required",
        min: { value: 1, message: "Usage limit must greater than 0" },
      },
      sm: 6,
      xs: 12,
    },
    {
      name: "valid_from",
      label: "Valid From *",
      placeholder: "Select date",
      type: "datebooking",
      instantBooking: "true",
      rules: {
        required: "Date is required",
        validate: {
          notPastDate: (value) => {
            if (!value) return true;

            console.log("Input value:", value);

            // Parse DD-MM-YYYY format into Date object
          const [day, month, year] = value.split(/[-/]/);

            if (!day || !month || !year) return "Invalid date format";

            const inputDate = new Date(`${year}-${month}-${day}`);
            // if (isNaN(inputDate.getTime())) return "Invalid date";

            // Get today's date without time
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            console.log("InputDate:", inputDate, "Today:", today);

            return inputDate >= today || "Cannot select past dates";
          },
        },
      },
      xs: 12,
      sm: 6,
    },
  {
  name: "valid_to",
  label: "Valid To *",
  placeholder: "Select date",
  type: "datebooking",
  instantBooking: "true",
  rules: {
    required: "Date is required",
validate: (value) => {
  if (!formValue.valid_from || !value) return true;

  // Normalize both dates to use "-" instead of "/"
  const fromDateStr = formValue.valid_from.replace(/\//g, "-");
  const toDateStr = value.replace(/\//g, "-");

  // Split into components
  const [fromDay, fromMonth, fromYear] = fromDateStr.split("-");
  const [toDay, toMonth, toYear] = toDateStr.split("-");

  // Create Date objects for comparison
  const fromDate = new Date(Number(fromYear), Number(fromMonth) - 1, Number(fromDay));
  const toDate = new Date(Number(toYear), Number(toMonth) - 1, Number(toDay));

  // Optional: log normalized format
  console.log("Valid From:", `${fromDay}-${fromMonth}-${fromYear}`);
  console.log("Valid To:", `${toDay}-${toMonth}-${toYear}`);

  // Validation check
  if (isNaN(fromDate.getTime()) || isNaN(toDate.getTime())) {
    return "Invalid date format";
  }

  return (
    toDate >= fromDate ||
    "Valid To date must be greater than or equal to Valid From date"
  );
}

  },
  xs: 12,
  sm: 6,
}
,
    {
      name: "applicable_platform",
      label: "Applicable Platform *",
      placeholder: "Select Platform",
      options: [
        { value: 1, label: "Web" },
        { value: 2, label: "App" },
        { value: 3, label: "Both" },
      ],
      rules: {
        required: "Please select a platform",
      },
      xs: 12,
      sm: 6,
    },
    {
      name: "description",
      label: "Description ",
      placeholder: "Enter Promo Code Description ",
      type: "textarea",
      xs: 12,
    },
  ];


  if (createPromoCodeSuccess) {
    toast.success(createPromoCodeSuccess, {
      position: "top-center",
      autoClose: 3000,
      onClose: () => {
        dispatch(resetCreatePromoCode());
        reset();
        setTab(0);
      },
    });
  }

  if (createPromoCodeError) {
    toast.error(createPromoCodeError, {
      position: "top-center",
      autoClose: 3000,
      onClose: () => {
        dispatch(resetCreatePromoCode());
      },
    });
  }

  const onSubmit = (data) => {
    data.discount_type = data.discount_type.value;
    data.discount_percent = data.discount_percent || 0;
    data.discount_value = data.discount_value || 0;
    data.applicable_platform = data.applicable_platform.value;
  data.valid_from= convertDateFormat(data.valid_from);
      data.valid_to= convertDateFormat(data.valid_to);
    dispatch(createPromoCodeRequest(data));
  };

  return (
    <Box className="container" sx={{ padding: "20px" }}>
      <Card>
        <CardContent className="card" sx={{ padding: "30px" }}>
          <Typography variant="h5" className="form-heading" mb={2}>
            Create Promo Code
          </Typography>
          <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
            <Grid
              container
              rowSpacing={4}
              columnSpacing={{ xs: 1, sm: 1, md: 1, lg: 3 }}
              className="customer-form-margin"
              sx={{
                maxHeight: "70vh",
                overflowY: "auto",
                paddingRight: "10px",
                "&::-webkit-scrollbar": {
                  width: "8px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f1f1f1",
                  borderRadius: "4px",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#c1c1c1",
                  borderRadius: "4px",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: "#a8a8a8",
                },
              }}
            >
              {promoFields.map((field) => (
                <Grid item xs={field.xs} sm={field.sm} key={field.name}>
                  <ControlledTextInputField
                    name={field.name}
                    control={control}
                    label={field.label}
                    multiple={field.multiple}
                    placeholder={field.placeholder}
                    options={field.options}
                    rules={field.rules}
                    instantBooking={field.instantBooking}
                    type={field.type}
                    error={!!errors[field.name]}
                    helperText={errors[field.name]?.message}
                  />
                </Grid>
              ))}
            </Grid>

            {/* Fixed Button Container at Bottom */}
            <Box
              className="button-container"
              sx={{
                marginTop: "20px",
                paddingTop: "20px",
                borderTop: "1px solid #e0e0e0",
                position: "sticky",
                bottom: 0,
                backgroundColor: "white",
                zIndex: 10,
              }}
            >
              <CustomButton
                variant="contained"
                className="cancel-button"
                type="button"
                text="Back"
                onClick={() => {
                  setTab(0);
                }}
                link={PROMOCODE}
              />
              <CustomButton
                variant="contained"
                className="success-button"
                type="submit"
                loading={loading}
                text={"Submit"}
              />
            </Box>
          </form>
          <ToastContainer />
        </CardContent>
      </Card>
    </Box>
  );
}

// // import React, { useEffect, useState } from "react";
// // import { Grid, Typography, Box, Paper } from "@mui/material";
// // import { useForm } from "react-hook-form";
// // import { useDispatch, useSelector } from "react-redux";
// // import { ToastContainer, toast } from "react-toastify";
// // import "react-toastify/dist/ReactToastify.css";

// // import ControlledTextInputField from "../../component/ui/FormFields/ControlledTextInputField";
// // import CustomButton from "../../component/ui/FormFields/Button";
// // import {
// //   addAirportRequest,
// //   resetAirportState,
// // } from "../../redux/Airports/actions/airportActions";
// // import {
// //   selectCountryAirportRequest,
// //   selectStateAirportRequest,
// // } from "../../redux/Common/selectorAction";

// // import { AIRPORTS, PROMOCODE } from "../../component/common/Routes/AppRoutes";
// // import { useNavigate } from "react-router-dom";
// // import {
// //   LocationOn,
// //   FlightLand,
// //   FlightTakeoff,
// //   TransferWithinAStation,
// // } from "@mui/icons-material";
// // import { fetchAllServiceRequest } from "../../redux/Service/ServiceAction";
// // import { min } from "date-fns";
// // import { createPromoCodeRequest } from "../../redux/PromoCode/PromoCodeAction";

// // export default function CreatePromoCode({ setTab }) {
// //   const dispatch = useDispatch();
// //   const [discountType, setDiscountType] = useState();
// //   const {
// //     control,
// //     handleSubmit,
// //     watch,
// //     setValue,
// //     formState: { errors },
// //   } = useForm({
// //     defaultValues: {},
// //     mode: "onChange",
// //   });
// //   const formValue = watch();

// //   const loading=useSelector((state)=>state.promoCode.promoCode.loading)

// //  useEffect(()=>{

// //       if(formValue.discount_type?.value=="1"){

// //         setValue("discount_value","")
// //       }
// //       else{
// //         setValue("discount_percent","")
// //       }
// //  },[formValue.discount_type])

// //  useEffect(()=>{
// //     setDiscountType(formValue?.discount_type?.value)
// //  },[formValue.discount_type])

// //   const promoFields = [
// //     {
// //       name: "title",
// //       label: "Title *",
// //       placeholder: "Enter PromoCode Title",
// //       rules: { required: "Discount Title is required" },
// //       sm: 6,
// //     },

// //     {
// //       name: "discount_code",
// //       label: "Discount Code *",
// //       placeholder: "Enter Discount Code",
// //       rules: {
// //         required: "Discount Code is required",
// //         validate: (value) => {
// //           if (value.length < 4) {
// //             return "Discount Code must be at least 4 characters";
// //           }
// //           if (value.length > 8) {
// //             return "Discount Code must not exceed 8 characters";
// //           }
// //           return true;
// //         },
// //       },
// //       sm: 6,
// //     },
// //     {
// //       name: "discount_type",
// //       label: "Discount Type",
// //       placeholder: "Select Discount Type",
// //       options: [
// //         { value: "2", label: "Price ($)" },
// //         { value: "1", label: "Discount(%)" },
// //       ],
// //       rules: {
// //         required: "Select Discount Type",
// //       },
// //       sm: 6,
// //     },
// //     ...(discountType == "2"
// //       ? [
// //           {
// //             name: "discount_value",
// //             label: "Discount Value *",
// //             placeholder: "Enter Discount Value",
// //             rules: { required: "Discount Value is required" },
// //             sm: 6,
// //           },
// //         ]
// //       : [
// //           {
// //             name: "discount_percent",
// //             label: "Discount Percentage *",
// //             placeholder: "Enter Discount Percentage 0-100%",
// //             rules: {
// //               required: "Percentage is required",
// //               min: { value: 0, message: "Percentage should not be negative" },
// //               max: {
// //                 value: 100,
// //                 message: "Percentage must be less than or equal to 100",
// //               },
// //             },
// //             sm: 6,
// //           },
// //         ]),

// //     {
// //       name: "usage_limit",
// //       label: "Use Limit *",
// //       placeholder: "Set Promo Code Use Limit",
// //       rules: {
// //         required: "Promo Code Limit is Required",
// //         min: { value: 1, message: "Usage limit must greater than 0" },
// //       },

// //       sm: 6,
// //     },

// //     {
// //       name: "valid_from",
// //       label: "Valid From *",
// //       placeholder: "Select date ",
// //         type: "dob",

// //       rules: { required: "Date is required" },
// //       xs: 12,
// //       sm: 6,
// //     },
// //    {
// //   name: "valid_to",
// //   label: "Valid To *",
// //   placeholder: "Select date",
// //   type: "dob",
// //   rules: {
// //     required: "Date is required",
// //     validate: (value) => {
// //       const fromDate = new Date(formValue.valid_from);
// //       const toDate = new Date(value);

// //       if (isNaN(fromDate.getTime()) || isNaN(toDate.getTime())) {
// //         return true; // Skip validation if one of the dates is empty
// //       }
// //       console.log("fromDate", fromDate);
// //       console.log("toDate", toDate);
// //       if (toDate < fromDate) {
// //         return "Valid To date must be greater than or equal to Valid From date";
// //       }

// //       return true;
// //     },
// //   },
// //   xs: 12,
// //   sm: 6,
// // },

// //     {
// //       name: "description",
// //       label: "Description ",
// //       placeholder: "Enter Promo Code Description ",
// //       type: "textarea",

// //       xs: 12,
// //     },
// //   ];

// //   const onSubmit = (data) => {

// //     data.discount_type=data.discount_type.value;
// //     data.discount_percent=data.discount_percent||0;
// //     data.discount_value=data.discount_value||0;
// //     dispatch(createPromoCodeRequest(data));
// //   };

// //   return (
// //     <Box component={Paper} sx={{ margin: "30px", padding: "30px" }}>
// //       <Typography variant="h5" mb={2}>
// //         Create Promo Code
// //       </Typography>
// //       <form onSubmit={handleSubmit(onSubmit)}>
// //         <Grid container spacing={2}>
// //           {promoFields.map((field) => (
// //             <Grid item xs={12} sm={field.sm} key={field.name}>
// //               <ControlledTextInputField
// //                 name={field.name}
// //                 control={control}
// //                 label={field.label}
// //                 multiple={field.multiple}
// //                 placeholder={field.placeholder}
// //                 options={field.options}
// //                 rules={field.rules}
// //                 instantBooking={field.instantBooking}
// //                 type={field.type}
// //                 error={!!errors[field.name]}
// //                 helperText={errors[field.name]?.message}
// //               />
// //             </Grid>
// //           ))}

// //           <Grid item xs={12}>
// //             <Box className="button-container">
// //               <CustomButton
// //                 variant="contained"
// //                 className="cancel-button"
// //                 type="button"
// //                 text="Back"
// //                 onClick={() => {
// //                   setTab(0);
// //                 }}
// //                 link={PROMOCODE}
// //               />
// //               <CustomButton
// //                 variant="contained"
// //                 className="success-button"
// //                 type="submit"
// //                 loading={loading}
// //                 text={"Submit"}
// //               />
// //             </Box>
// //           </Grid>
// //         </Grid>
// //       </form>
// //       <ToastContainer />
// //     </Box>
// //   );
// // }
// import React, { useEffect, useState } from "react";
// import { Grid, Typography, Box, Paper, Card, CardContent } from "@mui/material";
// import { useForm } from "react-hook-form";
// import { useDispatch, useSelector } from "react-redux";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// import ControlledTextInputField from "../../component/ui/FormFields/ControlledTextInputField";
// import CustomButton from "../../component/ui/FormFields/Button";
// import {
//   addAirportRequest,
//   resetAirportState,
// } from "../../redux/Airports/actions/airportActions";
// import {
//   selectCountryAirportRequest,
//   selectStateAirportRequest,
// } from "../../redux/Common/selectorAction";

// import { AIRPORTS, PROMOCODE } from "../../component/common/Routes/AppRoutes";
// import { useNavigate } from "react-router-dom";
// import {
//   LocationOn,
//   FlightLand,
//   FlightTakeoff,
//   TransferWithinAStation,
// } from "@mui/icons-material";
// import { fetchAllServiceRequest } from "../../redux/Service/ServiceAction";
// import { min } from "date-fns";
// import { createPromoCodeRequest, resetCreatePromoCode } from "../../redux/PromoCode/PromoCodeAction";

// export default function CreatePromoCode({ setTab }) {
//   const dispatch = useDispatch();
//   const [discountType, setDiscountType] = useState();
//   const {
//     control,
//     handleSubmit,
//     watch,
//     reset,
//     setValue,
//     formState: { errors },
//   } = useForm({
//     defaultValues: {},
//     mode: "onChange",
//   });
//   const formValue = watch();

//   const loading = useSelector((state) => state.promoCode.promoCode.loading);
//   const navigate = useNavigate();
//   const createPromoCodeSuccess = useSelector((state) => state.promoCode.promoCode.success);
//   const createPromoCodeError = useSelector((state) => state.promoCode.promoCode.error);

//   useEffect(() => {
//     if (formValue.discount_type?.value == "1") {
//       setValue("discount_value", "");
//     } else {
//       setValue("discount_percent", "");
//     }
//   }, [formValue.discount_type]);

//   useEffect(() => {
//     setDiscountType(formValue?.discount_type?.value);
//   }, [formValue.discount_type]);

//   const promoFields = [
//     {
//       name: "title",
//       label: "Title *",
//       placeholder: "Enter PromoCode Title",
//       rules: { required: "Discount Title is required" },
//       sm: 6,
//       xs: 12,
//     },
//     {
//       name: "discount_code",
//       label: "Discount Code *",
//       placeholder: "Enter Discount Code",
//       rules: {
//         required: "Discount Code is required",
//         validate: (value) => {
//           if (value.length < 4) {
//             return "Discount Code must be at least 4 characters";
//           }
//           if (value.length > 8) {
//             return "Discount Code must not exceed 8 characters";
//           }
//           return true;
//         },
//       },
//       sm: 6,
//       xs: 12,
//     },
//     {
//       name: "discount_type",
//       label: "Discount Type",
//       placeholder: "Select Discount Type",
//       options: [
//         { value: "2", label: "Price ($)" },
//         { value: "1", label: "Discount(%)" },
//       ],
//       rules: {
//         required: "Select Discount Type",
//       },
//       sm: 6,
//       xs: 12,
//     },
//     ...(discountType == "2"
//       ? [
//           {
//             name: "discount_value",
//             label: "Discount Value *",
//             placeholder: "Enter Discount Value",
//             rules: { required: "Discount Value is required" },
//             sm: 6,
//             xs: 12,
//           },
//         ]
//       : [
//           {
//             name: "discount_percent",
//             label: "Discount Percentage *",
//             placeholder: "Enter Discount Percentage 0-100%",
//             rules: {
//               required: "Percentage is required",
//               min: { value: 0, message: "Percentage should not be negative" },
//               max: {
//                 value: 100,
//                 message: "Percentage must be less than or equal to 100",
//               },
//             },
//             sm: 6,
//             xs: 12,
//           },
//         ]),
//     {
//       name: "usage_limit",
//       label: "Use Limit *",
//       placeholder: "Set Promo Code Use Limit",
//       rules: {
//         required: "Promo Code Limit is Required",
//         min: { value: 1, message: "Usage limit must greater than 0" },
//       },
//       sm: 6,
//       xs: 12,
//     },
//     {
//       name: "valid_from",
//       label: "Valid From *",
//       placeholder: "Select date ",
//       type: "dob",
//       rules: { required: "Date is required" },
//       xs: 12,
//       sm: 6,
//     },
//     {
//       name: "valid_to",
//       label: "Valid To *",
//       placeholder: "Select date",
//       type: "dob",
//       rules: {
//         required: "Date is required",
//         validate: (value) => {
//           const fromDate = new Date(formValue.valid_from);
//           const toDate = new Date(value);

//           if (isNaN(fromDate.getTime()) || isNaN(toDate.getTime())) {
//             return true; // Skip validation if one of the dates is empty
//           }
//           if (toDate < fromDate) {
//             return "Valid To date must be greater than or equal to Valid From date";
//           }
//           return true;
//         },
//       },
//       xs: 12,
//       sm: 6,
//     },
//     {
//       name: "description",
//       label: "Description ",
//       placeholder: "Enter Promo Code Description ",
//       type: "textarea",
//       xs: 12,
//     },
//   ];
//   if (createPromoCodeSuccess) {
//     toast.success(createPromoCodeSuccess, {
//       position: 'top-center',
//       autoClose: 3000,
//       onClose: () => {
//         dispatch(resetCreatePromoCode());
//         reset()
//            setTab(0);
//       },
//     });
//   }

//   if (createPromoCodeError) {
//     toast.error(createPromoCodeError, {
//       position: 'top-center',
//       autoClose: 3000,
//       onClose: () => {
//         dispatch(resetCreatePromoCode());

//       },
//     });
//   }
//   const onSubmit = (data) => {
//     data.discount_type = data.discount_type.value;
//     data.discount_percent = data.discount_percent || 0;
//     data.discount_value = data.discount_value || 0;
//     dispatch(createPromoCodeRequest(data));
//   };

//   return (
//     <Box className="container" sx={{ padding: "20px" }}>
//       <Card>
//         <CardContent className="card" sx={{ padding: "30px" }}>
//           <Typography variant="h5" className="form-heading" mb={2}>
//             Create Promo Code
//           </Typography>
//           <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
//             <Grid
//               container
//               rowSpacing={4}
//               columnSpacing={{ xs: 1, sm: 1, md: 1, lg: 3 }}
//               className="customer-form-margin"
//               sx={{
//                 maxHeight: "70vh",
//                 overflowY: "auto",
//                 paddingRight: "10px",
//                 '&::-webkit-scrollbar': {
//                   width: '8px',
//                 },
//                 '&::-webkit-scrollbar-track': {
//                   background: '#f1f1f1',
//                   borderRadius: '4px',
//                 },
//                 '&::-webkit-scrollbar-thumb': {
//                   background: '#c1c1c1',
//                   borderRadius: '4px',
//                 },
//                 '&::-webkit-scrollbar-thumb:hover': {
//                   background: '#a8a8a8',
//                 },
//               }}
//             >
//               {promoFields.map((field) => (
//                 <Grid item xs={field.xs} sm={field.sm} key={field.name}>
//                   <ControlledTextInputField
//                     name={field.name}
//                     control={control}
//                     label={field.label}
//                     multiple={field.multiple}
//                     placeholder={field.placeholder}
//                     options={field.options}
//                     rules={field.rules}
//                     instantBooking={field.instantBooking}
//                     type={field.type}
//                     error={!!errors[field.name]}
//                     helperText={errors[field.name]?.message}
//                   />
//                 </Grid>
//               ))}
//             </Grid>

//             {/* Fixed Button Container at Bottom */}
//             <Box
//               className="button-container"
//               sx={{
//                 marginTop: "20px",
//                 paddingTop: "20px",
//                 borderTop: "1px solid #e0e0e0",
//                 position: "sticky",
//                 bottom: 0,
//                 backgroundColor: "white",
//                 zIndex: 10,
//               }}
//             >
//               <CustomButton
//                 variant="contained"
//                 className="cancel-button"
//                 type="button"
//                 text="Back"
//                 onClick={() => {
//                   setTab(0);
//                 }}
//                 link={PROMOCODE}
//               />
//               <CustomButton
//                 variant="contained"
//                 className="success-button"
//                 type="submit"
//                 loading={loading}
//                 text={"Submit"}
//               />
//             </Box>
//           </form>
//           <ToastContainer />
//         </CardContent>
//       </Card>
//     </Box>
//   );
// }
